// src/utils/discussionUtils.ts
export const getCompositeKey = (blogId: number, discussionId: number) => 
  `${blogId}-${discussionId}`;